import { render, staticRenderFns } from "./DesignationIntro.vue?vue&type=template&id=4fa46fba&scoped=true"
import script from "./DesignationIntro.vue?vue&type=script&lang=js"
export * from "./DesignationIntro.vue?vue&type=script&lang=js"
import style0 from "./DesignationIntro.vue?vue&type=style&index=0&id=4fa46fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa46fba",
  null
  
)

export default component.exports